









































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe, institutionServer, performanceServer, userServe } from '@/api/installServer';
import { dutyListTemplateServer } from '@/api/installServer';
import { dutyListBatchServer } from '@/api/installServer';
import SafetyAndEnvironmentDialog from '@/views/inspectionContents/safetyAndEnvironmentAssessment/unit/safetyAndEnvironmentDialog.vue';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { SafetyAndEnvironmentDialog },
})
export default class EditBatchDialog extends Vue {
  @Prop(Object) editData!: any; // 传递给编辑页面-数据对象
  @Prop(String) NewType!: any; // 传递给编辑页面-类型
  // 表单数据
  formData: any = {
    name: '',
    year: '',
    dutyRuleListTemplateId: '',
    dutyRuleListTemplateName: '',
    memberList: [],
    executeCompanyId: '',
    executeCompanyName: '',
    executeStaffList: [],
  };

  buttonShowFlag: any = true;
  isLoading: any = false; // 点击确定之后
  frequencyOptions: any = [];
  // 公司列表(选中列表)
  activeCompanyName: any = '';
  // 模板列表选项
  templateListOptions: any = [];
  templateDetailsData: any = {};
  // 当前正在编辑的公司履职清单的某个条目
  currentCompanyDutyListItem: any = {};
  taskTypeOptions: any = [
    {
      value: '固定',
      label: '固定',
    },
    {
      value: '动态',
      label: '动态',
    },
  ];

  private subSpaceByAuthOptions: any = []; // 企业  部门
  private staffOptions: any = []; // 人员

  /**
   * @desc Vue 创建数据钩子函数
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    // 获取频次数据
    this.getFrequencyData();
    this.getSubSpaceByAuth(); // 部门、企业
    if (this.NewType === 'add') {
      const a: any = new Date().getFullYear();
      this.formData.year = a.toString();
    } else {
      this.getDetails();
      if (this.NewType === 'see') {
        this.buttonShowFlag = false;
      }
    }
  }
  /**
   * 公司选中发生修改
   */
  companyPrincipalChoose(e: any) {
    if (e) {
      this.formData.executeCompanyName = (this.$refs.cascaderCompanyDeptRef as any).getCheckedNodes()[0].label;
      // 获取人员数据
      this.getCompanyDeptStaffData();
      this.getTemplateList();
    } else {
      this.formData.executeCompanyName = '';
    }
    /*// 删除本次被取消选中的记录
    const currentCompanyValueList: any = [];
    this.companyPrincipalList.forEach((company: any) => {
      currentCompanyValueList.push(company.value);
    });
    this.formData.memberList = this.formData.memberList.filter((item: any) => currentCompanyValueList.indexOf(item.executeCompanyId) > -1);

    // 上次被选中的公司id
    const beforeMemberIdList: any = [];
    this.formData.memberList.forEach((member: any) => {
      beforeMemberIdList.push(member.executeCompanyId);
    });

    // 模板详情的条目
    const itemList: any = this.getMemberDutyListItemByTemplate();

    // 从公司选择器选中的公司加入member（成员列表中）
    this.companyPrincipalList.forEach((company: any) => {
      if (beforeMemberIdList.indexOf(company.value) === -1) {
        this.formData.memberList.push({
          id: null,
          executeCompanyId: company.value,
          executeCompanyName: company.label,
          executeStaffId: company.staffId,
          executeStaffName: company.staffName,
          itemList: JSON.parse(JSON.stringify(itemList)), // 从模板中写入
        });
      }
    });*/
  }
  changeStaffChoose(e: any) {
    // 模板详情的条目
    const itemList: any = this.getMemberDutyListItemByTemplate();
    if (e && e.length) {
      this.formData.memberList = e.map((item: any) => {
        return {
          executeCompanyId: this.formData.executeCompanyId,
          executeCompanyName: this.formData.executeCompanyName,
          executeStaffId: item.id,
          executeStaffName: item.name,
          itemList: JSON.parse(JSON.stringify(itemList)), // 从模板中写入
        };
      });
    }
  }

  /**
   * 选中模板的改变事件
   */
  changeTemplateChoose() {
    // 获取模板的详情
    dutyListTemplateServer
      .getTemplateDetails(this.formData.dutyRuleListTemplateId)
      .then((res: any) => {
        this.templateDetailsData = res.data;
        this.formData.dutyRuleListTemplateName = this.templateDetailsData.name;
        // 模板发生变化，对所有公司的履职清单进行更新
        // 模板详情的条目
        const itemList: any = this.getMemberDutyListItemByTemplate();
        this.formData.memberList.forEach((item: any) => {
          item.itemList = JSON.parse(JSON.stringify(itemList));
        });
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  /**
   * 从模板中获取成员的履职清单条目
   */
  getMemberDutyListItemByTemplate() {
    // 模板详情的条目
    let itemList: any = [];
    if (this.templateDetailsData && this.templateDetailsData.itemList) {
      itemList = this.templateDetailsData.itemList.map((item: any) => {
        return {
          ...item,
          id: null, // // 将从模板得来的id设置为null（null表示新增）
        };
      });
    }
    return itemList;
  }
  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
  getCompanyDeptStaffData() {
    userServe
      .getPageDataAll({ deptId: this.formData.executeCompanyId })
      .then((res: any) => {
        this.staffOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * 获取模板的选项列表
   */
  getTemplateList() {
    // 发起接口请求，获取分页数据
    dutyListTemplateServer
      .getTemplateAllList({ deptId: this.formData.executeCompanyId })
      .then((res: any) => {
        this.templateListOptions = res.data || [];
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * 获取频次数据
   */
  getFrequencyData() {
    dictServe
      .getDetailsMapByName('frequency')
      .then((res: any) => {
        for (const key in res.data) {
          this.frequencyOptions.push({
            value: key,
            label: res.data[key],
          }); //属性
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取详情
   * @param1 暂无
   * @returns 暂无
   */
  getDetails() {
    dutyListBatchServer
      .getBatchRecordDetails(this.editData.id)
      .then((res: any) => {
        this.formData = res.data;
        if (this.formData.memberList && this.formData.memberList.length) {
          this.formData.executeCompanyId = this.formData.memberList[0].executeCompanyId;
          this.formData.executeCompanyName = this.formData.memberList[0].executeCompanyName;
          this.getCompanyDeptStaffData();
          this.getTemplateList();
          this.formData.executeStaffList = this.formData.memberList.map((item: any) => {
            return {
              id: item.executeStaffId,
              name: item.executeStaffName,
            };
          });
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  changeProject(companyDutyListItem: any, index: any) {
    if (!this.buttonShowFlag) return;
    this.currentCompanyDutyListItem = companyDutyListItem;
    // if (this.formData.assessType) {
    const safetyDialog = 'safetyDialog';
    const safetyDialogComponent = this.$refs[safetyDialog];
    (safetyDialogComponent as any).showDialog(companyDutyListItem.assessType); // 传给弹窗的数据 检查标准项(即 检查内容)
    // } else {
    //     this.$message.warning('请先选择考核类型！');
    // }
  }

  /**
   * @desc 检查内容弹窗中所选的数据
   * */
  getData(data: any) {
    if (data) {
      this.currentCompanyDutyListItem.assessContent = data.assessContent;
      this.currentCompanyDutyListItem.assessStand = data.assessStand;
      this.currentCompanyDutyListItem.assessContentId = data.id;
      this.currentCompanyDutyListItem.assessProjectName = data.assessProject;
    } else {
      this.currentCompanyDutyListItem.assessContent = '';
      this.currentCompanyDutyListItem.assessStand = '';
      this.currentCompanyDutyListItem.assessContentId = '';
      this.currentCompanyDutyListItem.assessProjectName = '';
    }
    this.$forceUpdate();
  }

  private addList(companyIndex: any) {
    this.formData.memberList[companyIndex].itemList.push({
      assessContent: '',
      assessContentId: '',
      assessProjectName: '',
      assessStand: '',
      dutyContent: '',
      frequency: 0,
      frequencyUnit: '',
      referWeights: 0,
      remark: '',
      type: '',
    });
  }

  private delList(company: any, index: any) {
    if (company.itemList.length === 1) {
      (this as any).$message.warning('至少保留一项');
      return false;
    }
    company.itemList.splice(index, 1);
  }

  /**
   * @desc 点击取消按钮
   */
  close() {
    this.isLoading = false;
    this.formData = {};
    this.$emit('refreshData');
  }

  /**
   * @desc 点击保存
   */
  saveClick() {
    console.log('点击保存');
    dutyListBatchServer
      .addBatchRecord({
        dutyRuleListTemplateId: this.formData.dutyRuleListTemplateId,
        dutyRuleListTemplateName: this.formData.dutyRuleListTemplateName,
        name: this.formData.name,
        year: this.formData.year,
        memberList: this.formData.memberList,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功！');
          this.close();
        } else {
          this.isLoading = false;
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
        this.$message.warning('新增数据失败！');
      });
  }

  /**
   * 保存修改内容
   */
  saveEditClick() {
    dutyListBatchServer
      .editBatchRecord(this.formData.id, {
        dutyRuleListTemplateId: this.formData.dutyRuleListTemplateId,
        dutyRuleListTemplateName: this.formData.dutyRuleListTemplateName,
        name: this.formData.name,
        year: this.formData.year,
        memberList: this.formData.memberList,
        id: this.formData.id,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('保存成功！');
          this.close();
        } else {
          this.isLoading = false;
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
        this.$message.warning('修改数据失败！');
      });
  }

  /**
   * 保存或者修改前对数据的处理
   */
  saveOrEditBeforeDataHandle() {
    this.isLoading = true;
    this.formData.memberList.forEach((item: any) => {
      item.itemList.forEach((re: any) => {
        re.frequency = parseInt(re.frequency);
        re.referWeights = parseInt(re.referWeights);
      });
    });
    if (this.NewType === 'add') {
      this.saveClick();
    } else {
      this.saveEditClick();
    }
  }
}
